import { debugBar } from '@freedom/debug-bar';

import { appConfig } from '@/shared/config';

export const withDebugBar = async () => {
  if (!appConfig.isProdRuntimeEnv) {
    debugBar.init();
  }
};
